var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container",attrs:{"id":"app"}},[_c('NavbarComponent'),_c('main',{staticClass:"main-content"},[_c('router-view')],1),_c('FooterComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }